import React, { useEffect } from 'react';
import WebLayout from '@/Layouts/WebLayout';

export default function Politicasdeenvio({ politicDev  }) {

  return (
    <>
      <main>

        <section className="w-10/12 mx-auto space-y-6">
          <h2 className="font-semibold font-poppins text-slate-800 text-center text-3xl tracking-tight pt-8">Políticas de Devolución</h2>
          <div className="font-poppins text-[#151515] flex flex-col gap-16">

            <div className="grid grid-cols-1 ">

              <div dangerouslySetInnerHTML={{ __html: politicDev?.content }} />

            </div>
          </div>
        </section>

      </main>
    </>
  )
}

Politicasdeenvio.layout = page => <WebLayout children={page} />;